export type ExpenseCategoryConfig = {
  id: string;
  name: string;
  description: string;
};

export const expenseCategories: ExpenseCategoryConfig[] = [
  {
    id: "NDIS_SERVICES",
    name: "NDIS Services",
    description: "Services provided by an NDIS provider internally using the claim function."
  },
  {
    id: "ACCOMMODATION",
    name: "Accommodation",
    description: "Costs related to temporary stay such as hotels, motels, or short-term rentals."
  },
  {
    id: "TRAVEL",
    name: "Travel",
    description: "Costs for commercial flights undertaken for business purposes."
  },
  {
    id: "AUTOMOBILE_MOTOR_VEHICLE",
    name: "Automobile/Motor Vehicle",
    description:
      "Expenses related to company vehicles or employee vehicle use including fuel, maintenance, registration, insurance, and tolls."
  },
  {
    id: "CLIENT_ENTERTAINMENT_MEALS",
    name: "Client Entertainment/Meals",
    description: "Costs incurred for entertaining clients, including meals and hospitality."
  },
  {
    id: "CLIENT_EXPENSES",
    name: "Client Expenses",
    description: "Costs incurred in the process of providing support workers to a client."
  },
  {
    id: "COMMUNICATION",
    name: "Communication",
    description: "Mobile phone bills, internet service, and landlines for business use."
  },
  {
    id: "CONFERENCES_TRAINING",
    name: "Conferences & Training",
    description: "Fees for professional development, seminars, workshops, and associated travel or accommodation."
  },
  {
    id: "CONSULTING_CONTRACTOR_FEES",
    name: "Consulting/Contractor Fees",
    description: "Payments to external consultants, freelancers, or independent contractors."
  },
  {
    id: "EQUIPMENT_SUPPLIES",
    name: "Equipment & Supplies",
    description:
      "Purchase of office equipment such as laptops and furniture as well as general office supplies like stationery or printing."
  },
  {
    id: "INSURANCE",
    name: "Insurance",
    description: "Business insurance premiums including public liability and professional indemnity policies."
  },
  {
    id: "MARKETING_ADVERTISING",
    name: "Marketing & Advertising",
    description:
      "Costs associated with promoting the business, including digital ads, print media, and public relations."
  },
  {
    id: "OTHER_TRAVEL_EXPENSES",
    name: "Other Travel Expenses",
    description:
      "Local transportation such as taxis, ride-share, public transport, parking, and minor incidentals during travel."
  },
  {
    id: "POSTAGE_COURIER",
    name: "Postage & Courier",
    description: "Costs for sending and receiving business correspondence and parcels."
  },
  {
    id: "RENT_LEASE",
    name: "Rent/Lease",
    description: "Payments for leasing office space, equipment, or machinery."
  },
  {
    id: "REPAIRS_MAINTENANCE",
    name: "Repairs & Maintenance",
    description: "Costs to keep business assets and property in good working order."
  },
  {
    id: "SALARIES_WAGES",
    name: "Salaries & Wages",
    description: "Employee remuneration costs that complement payroll records for holistic reporting."
  },
  {
    id: "SOFTWARE_SUBSCRIPTIONS",
    name: "Software & Subscriptions",
    description: "Fees for necessary business software, cloud services, and professional subscriptions."
  },
  {
    id: "SUPERANNUATION_CONTRIBUTIONS",
    name: "Superannuation Contributions",
    description: "Employer-paid superannuation guarantee contributions."
  },
  {
    id: "UTILITIES",
    name: "Utilities",
    description: "Electricity, gas, and water charges for business premises."
  }
];
